// extracted by mini-css-extract-plugin
module.exports = {"Container":"Notes_Container__UZmK7"};